import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
// import Index from './components/index.vue'
import store from './store/index'
import Routes from './routes'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

const router = new VueRouter({
  routes: Routes,
  mode: 'history'
})

Vue.use(VueResource)
Vue.use(VueRouter)

new Vue({
  store,
  render: h => h(App),
  router: router
}).$mount('#app')

// let ChinaMap = new Vue({
//   el: '#app',
//   store,
//   template: '<Index/>',
//   components: {Index}
// })

// Vue.use(ChinaMap)
